import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { MatLegacyProgressBarModule as MatProgressBarModule } from '@angular/material/legacy-progress-bar';

@Component({
  selector: 'update-client-file-template',
  standalone: true,
  imports: [
    FormsModule,
    MatButtonModule,
    MatTooltipModule,
    MatProgressBarModule,
    MatIconModule
  ],
  templateUrl: './update-client-file-template.component.html',
  styleUrl: './update-client-file-template.component.scss'
})
export class UpdateClientFileTemplateComponent {
  @Input() isPendingFileDownload: boolean;
  @Input() downloadPercentageProgress: number;
  @Input() localFile: File;
  @Input() acceptFile: string;
  @Input() filePath: string;

  @Output() filePathChange = new EventEmitter<string>();
  @Output() setDefaultPath = new EventEmitter<void>();
  @Output() setFileData = new EventEmitter<File>();
  @Output() save = new EventEmitter<void>();
  @Output() uploadFile = new EventEmitter<void>();

}
